import React from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';
import { getAuth } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import WeekAnimation from '../../WeekAnimation';

export const WeekIntro = ({ story, action, isPaused, config, storyData }) => {
    const auth = getAuth();
    const [user] = useAuthState(auth);
    const firstName = user?.displayName?.split(" ")[0] ?? "";
    
    let welcomeMessage = `Let's get into it ${firstName}`;
    if (story.view === 'readOnly' && story.sharerName) {
        welcomeMessage = `A look into ${story.sharerName}'s experience`;
    }

    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused} areCommentsEnabled={false}>
            <h1 className={styles.size1} style={{ marginBottom: '0.5rem' }}>{storyData.data.titleInfo.week1}</h1>
            {storyData.data.titleInfo.week2 &&
                <>
                    <hr className={styles.divider}></hr>
                    <h1 className={styles.size1} style={{ margin: '0.5rem' }}>{storyData.data.titleInfo.week2}</h1>
                </>
            }
            <p style={{ margin: "1.5rem 0" }}>{welcomeMessage}</p>
            <WeekAnimation daysAndColors={storyData.data.daysAndColors} showCircleOnly={true} animationDuration={800}/>
        </StoryWrapper>
    );
};